import { Component, Input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppIconComponent } from '../../../../../../../common/components/icon/icon.component';
import { Gender } from '../../../../../../../core/data/enums/gender.enum';
import { InsuranceTypeDto } from '../../../../../../../core/data/dtos/insurance-type.dto';
import { DatepickerInputComponent } from '../../../../../../../common/components/datepicker-input/datepicker-input.component';

export const OTHER_RELATIONSHIPS = [
    { value: 'Madre', label: 'Madre' },
    { value: 'Padre', label: 'Padre' },
    { value: 'Hermano', label: 'Hermano(a)' },
    { value: 'Abuelo', label: 'Abuelo(a)' },
    { value: 'Nieto', label: 'Nieto(a)' },
    { value: 'Primo', label: 'Primo(a)' },
    { value: 'Tio', label: 'Tio(a)' },
    { value: 'Sobrino', label: 'Sobrino(a)' },
];

@Component({
    selector: 'app-other-dependents',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AppIconComponent,
        DatepickerInputComponent,
    ],
    templateUrl: './other-dependents.component.html',
})
export class OtherDependentsComponent {
    @Input({ required: true }) form!: FormGroup;
    @Input({ required: true }) option!: InsuranceTypeDto;
    @Input({ required: true }) othersArray!: FormArray<FormGroup>;

    addOtherEvent = output<void>();
    removeOtherEvent = output<number>();

    readonly Gender = Gender;
    readonly relationships = OTHER_RELATIONSHIPS;

    addOther(): void {
        this.addOtherEvent.emit();
    }

    removeOther(index: number): void {
        this.removeOtherEvent.emit(index);
    }
}
